import React from 'react';
import Parser from 'html-react-parser';

import './PricingContent.scss';

class PricingContent extends React.PureComponent {

  renderProcedures = () => {
    return this.props.langs.surgery.procedures.map((procedure) => {
      return (
        <div key={procedure.id} className="pricingContent_table_wrap">
          <table className="pricingContent_table">
            <thead>
            <tr>
              <th>{procedure.name}</th>
              <th/>
              {procedure.types[0].vzp && <th> Pro pojištěnce VZP</th>}
            </tr>
            </thead>
            <tbody>
            {procedure.types.map((type, index) => {
              return (
                <tr key={index}>
                  <td>{type.name}</td>
                  <td colSpan={type.vzp ? "1" : "2"}>{type.price}</td>
                  {type.vzp && <td>{type.vzp}</td>}
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>
      )
    });
  };

  render() {

    return (
      <section className="pricingContent">
        <div className="container">
          <div className="pricingContent_topText no-print">
            {Parser(this.props.langs.pricing.top_text)}
          </div>

          {this.renderProcedures()}
        </div>
      </section>
    );
  }
}

export default PricingContent;



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContent/PricingContent.js